import { render, staticRenderFns } from "./intentModal.vue?vue&type=template&id=a86072ba&scoped=true"
import script from "./intentModal.vue?vue&type=script&lang=js"
export * from "./intentModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a86072ba",
  null
  
)

export default component.exports